import styled, { css } from 'styled-components';
import { themeHelpers } from '@gotamedia/fluffy';
import FluffyIcon, { Icons, IconVariants } from '@gotamedia/fluffy/Icon';
import FluffyInput from '@gotamedia/fluffy/Input';
import FluffyInputGroup from '@gotamedia/fluffy/InputGroup';
import FluffySelect, { SelectTypes } from '@gotamedia/fluffy/Select';
import FluffyCheckbox from '@gotamedia/fluffy/Checkbox';
import FluffyButton from '@gotamedia/fluffy/Button';
const Wrapper = styled.div.withConfig({
  displayName: "style__Wrapper",
  componentId: "sc-c6rfl6-0"
})(["margin-top:32px;", ""], themeHelpers.isSmallDevice(css(["margin-top:16px;"])));
const SearchInputGroup = styled(FluffyInputGroup).withConfig({
  displayName: "style__SearchInputGroup",
  componentId: "sc-c6rfl6-1"
})(["width:100%;"]);
const SearchIcon = styled(FluffyIcon).attrs(() => {
  return {
    icon: Icons.MagnifyingGlass,
    variant: IconVariants.Solid
  };
}).withConfig({
  displayName: "style__SearchIcon",
  componentId: "sc-c6rfl6-2"
})([""]);
const SearchInput = styled(FluffyInput).withConfig({
  displayName: "style__SearchInput",
  componentId: "sc-c6rfl6-3"
})(["font-size:16px;"]);
const SelectsWrapper = styled.div.withConfig({
  displayName: "style__SelectsWrapper",
  componentId: "sc-c6rfl6-4"
})(["width:100%;display:flex;margin-top:12px;", ""], themeHelpers.isNotLargeDevice(css(["flex-direction:column;"])));
const SelectWrapper = styled.div.withConfig({
  displayName: "style__SelectWrapper",
  componentId: "sc-c6rfl6-5"
})(["flex:auto;display:flex;flex-direction:column;&:last-child{", " ", "}"], themeHelpers.isLargeDevice(css(["margin-left:12px;"])), themeHelpers.isNotLargeDevice(css(["margin-top:12px;"])));
const Label = styled.p.withConfig({
  displayName: "style__Label",
  componentId: "sc-c6rfl6-6"
})(["font-size:14px;line-height:18px;color:#8A8A8D;margin-bottom:4px;"]);
const Select = styled(FluffySelect).attrs(() => {
  return {
    isMultiSelect: true,
    showResetButton: true,
    showApplyButton: true,
    portalWhenMounted: true,
    closeOnScrollOutside: true,
    type: SelectTypes.Checkbox
  };
}).withConfig({
  displayName: "style__Select",
  componentId: "sc-c6rfl6-7"
})(["filter:none;"]);
const Checkbox = styled(FluffyCheckbox).withConfig({
  displayName: "style__Checkbox",
  componentId: "sc-c6rfl6-8"
})(["margin-top:12px;"]);
const SearchButton = styled(FluffyButton).withConfig({
  displayName: "style__SearchButton",
  componentId: "sc-c6rfl6-9"
})(["width:100%;margin-top:12px;"]);
const Spinner = styled(FluffyIcon).attrs(() => {
  return {
    spin: true,
    icon: Icons.ArrowPath
  };
}).withConfig({
  displayName: "style__Spinner",
  componentId: "sc-c6rfl6-10"
})([""]);
export { Wrapper, SearchInputGroup, SearchIcon, SearchInput, SelectsWrapper, SelectWrapper, Label, Select, Checkbox, SearchButton, Spinner };